import { useEffect } from 'react';
import {
    getCity,
    getCurrencyRates,
    getMainPageStats,
    getYears,
} from '../../redux/reducers/common/thunks/commonInfoThunks';
import TokenService from '../../services/network/tokenService';
import { setToken } from '../../services/network/api';
import { isAuthenticated } from '../../routing/isAuthenticated';
import { setIsAuthenticated } from '../../redux/reducers/account/auth';

export const useAppStartHooks = (store) => {
    useEffect(() => {
        const token = TokenService.getAccessToken();
        if (token) {
            setToken(token);
            if (isAuthenticated()) {
                store.dispatch(setIsAuthenticated(true));
            } else {
                TokenService.clear();
                store.dispatch(setIsAuthenticated(false));
            }
        }

        store.dispatch(getCurrencyRates());
        store.dispatch(getMainPageStats());
        store.dispatch(getYears());
        store.dispatch(getCity());
    }, [store]);
};
